import { BAILocale } from '.';
import pt_BR from 'antd/es/locale/pt_BR';

const localeValue: BAILocale = {
  lang: 'pt-BR',
  antdLocale: pt_BR,
};

export default localeValue;
